import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import * as CONSTANTS from "../../../services/constants";
import moment from "moment";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";
import DropMonthYear from "../../../components/DropMonthYear";

class Company extends Component {
  state = {
    load: false,
    documentsToUpload: {},
    companyDocuments: {},
    medicaoDocumentsToUpload: {},
    medicaoDocuments: {},
    showAprovacaoPeriodic: false,
    allDocumentsInDateAlreadySubmited: false,
    sectorId: null,
    erroDelete: false,
    rejectDocument: false,
    msgFile: "",
    employees: {},
    year: moment().format("YYYY"),
    month: CONSTANTS.months()[CONSTANTS.currMonth()]
  };

  //Após montar o componente
  async componentDidMount() {
    //Busca os documentos da empresa (que foram submetidos)
    await this.searchDocumentsCompany();

    //Busca os documentos do tipo Empresa Periódico
    await this.searchDocumentsToCompany();

    //Busca os documentos de medição da empresa (que foram submetidos)
    await this.searchMedicaoDocuments();

    //Busca os documentos de medição
    await this.searchMedicaoDocumentsToCompany();

    // await this.searchStatus();<-- Aparentemente não faz porra nenhuma neste componente

    //Retorna dados do usuário
    await this.searchDataEmployee(localStorage.getItem("CompanyId"));
  }

  //Busca os documentos mensais da empresa (que foram submetidos)
  searchDocumentsCompany = async () => {
    const { year, month } = this.state;
    const companyDocuments = await api.get(
      `/companies/${localStorage.getItem(
        "CompanyId"
      )}/attachments?DocumentTypeId=2&year=${year}&month=${month}`
    );
    console.log(
      "TCL: searchDocumentsCompany -> companyDocuments",
      companyDocuments
    );
    //Seta no estado
    this.setState({ companyDocuments: companyDocuments.data.rows });
  };

  //Busca status, descrição do status e setor responsável.
  verifyStatusCompany = async () => {
    await api
      .get(`/companies/${localStorage.getItem("CompanyId")}`)
      .then(result => {
        this.setState({
          companyStatus: result.data.data.CompanyStatusId,
          sectorId: result.data.data.SectorId
        });
      });

    try {
      const response = await api.get(
        `/companies?cnpj=${localStorage.getItem("cnpj")}`
      );
      if (response.data.rows.length) {
        let dados = response.data.rows[0];
        this.setState({
          companyStatusDescription: dados.CompanyStatus.description
        });
      }
    } catch (err) {}
  };

  //Retorna dados do usuário
  //TODO: Verificar se há a necessidade de setar dados no localStorage
  searchDataEmployee = async (companyId, filterNome, filterStatus) => {
    let name = filterNome ? `&name=${filterNome}` : "";
    let EmployeeStatusId = filterStatus
      ? `&EmployeeStatusId=${filterStatus}`
      : "";

    const dataEmployee = await api.get(
      `/employees?CompanyId=${companyId}${name}${EmployeeStatusId}`
    );
    this.setState({ employees: dataEmployee.data.rows });
  };

  // searchStatus = async () => {
  //   this.setState({ load: true });
  //   const response = await api.get(`/employee-status`);
  //   this.setState({ status: response.data.rows, load: false });
  // };

  //Busca os documentos do tipo Empresa Periódico
  searchDocumentsToCompany = async () => {
    const companyTypeDocuments = await api.get(
      `/company-types/${localStorage.getItem(
        "CompanyTypeId"
      )}/documents?DocumentTypeId=2`
    );

    // Seta no estado os documentos da empresa a serem submetidos
    this.setState({ documentsToUpload: companyTypeDocuments.data.data });
    this.sendApproval();
    this.verifyStatusCompany();
    this.verifyStatusDocuments();
  };

  //Busca os documentos de medição da empresa (que foram submetidos)
  searchMedicaoDocuments = async () => {
    const { year, month } = this.state;
    const medicaoDocuments = await api.get(
      `/companies/${localStorage.getItem(
        "CompanyId"
      )}/attachments?DocumentTypeId=5&year=${year}&month=${month}`
    );
    
    this.setState({
      medicaoDocuments: medicaoDocuments.data.rows
    });
  };

  //Busca os documentos de medição
  searchMedicaoDocumentsToCompany = async () => {
    const documentsToUpload = await api.get(
      `/company-types/${localStorage.getItem(
        "CompanyTypeId"
      )}/documents?DocumentTypeId=5`
    );

    this.setState({
      medicaoDocumentsToUpload: documentsToUpload.data.data
    });
  };


  // Retorna o nome do arquivo para label da lista
  verifyDocument = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].originalName : "";
  };

  // Verifica observação/justificativa quando reprovado
  verifyDocumentNote = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].note : "";
  };

  verifyDocumentExpired = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    if (exist.length > 0) {
      if (exist[0].expired) {
        return "Vencido";
      }
    }
  };

  verifyDocumentApplicable = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].notapplicable : false;
  };

  //Método para setar os documentos como não aplicáveis
  checkDocument = async e => {
    this.setState({ msgFile: "", load: true });
    const { year, month, rejectedDocument, companyStatus } = this.state;
    if (year && month) {
      const data = {
        DocumentId: e.target.value,
        notapplicable: e.target.checked ? true : false,
        year: year,
        month: month
      };

      try {
        var response = null;
        response = await api.post(
          `/companies/${localStorage.getItem("CompanyId")}/attachments`,
          data
        );
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: response.data.msg,
          classText: "text-success",
          load: false
        });
        this.searchDocumentsCompany();
        this.searchDocumentsToCompany();
      } catch (err) {
        if (err) {
          console.log("TCL: verifyStatusCompany -> err", err);
          this.setState({
            msgAlert: err.response,
            classText: "text-danger"
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger"
          });
        }
      }
    } else {
      document.getElementById(`${e.target.id}`).value = "";
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: "Selecione o mês e ano de competência dos documentos!",
        classText: "text-danger",
        load: false
      });
    }
  };

  showFileButton = id =>
    this.state.companyStatus === 2 ||
    this.state.companyStatus === 3 ||
    // !this.state.rejectDocument ||
    // this.state.companyStatus === 5 &&
    this.verifyDocumentIcon(id) === "fa fa-check text-success" ||
    this.verifyDocumentIcon(id) === "fa fa-clock-o" ||
    this.verifyDocumentIcon(id) === "" ||
    this.verifyDocumentExpired(id) === "Vencido"
      ? false
      : true;

  uploadDocument = async e => {
    const { month, year, companyDocuments, companyStatus } = this.state;
    // Status do DOCUMENTO 4 : Rejeitado
    const rejectedDocument = companyDocuments.filter(
      item => item.AttachmentStatusId === 4
    );

    if (year && month) {
      if (e.target.files.length > 0) {
        this.setState({ msgFile: "", load: true });

        const formData = new FormData();
        formData.append("attachment", e.target.files[0]);
        formData.append("DocumentId", e.target.id);
        formData.append("year", year);
        formData.append("month", month);
        const config = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };

        try {
          var response = null;
          if (rejectedDocument.length > 0 || companyStatus === 4) {
            response = await api.patch(
              `/companies/${localStorage.getItem("CompanyId")}/attachments`,
              formData,
              config
            );
          } else {
            response = await api.post(
              `/companies/${localStorage.getItem("CompanyId")}/attachments`,
              formData,
              config
            );
          }

          document.getElementById("modal-alert").click();
          this.setState({
            msgAlert: response.data.msg,
            classText: "text-success",
            load: false
          });

          this.searchDocumentsCompany();
          this.searchDocumentsToCompany();
        } catch (err) {
          if (err && err.response.data.errors[0]) {
            this.setState({
              msgAlert: err.response.data.errors[0].msg,
              classText: "text-danger"
            });
          } else {
            this.setState({
              msgAlert: "Erro no envio. Tente novamente!",
              classText: "text-danger"
            });
          }
        }
      }
    } else {
      document.getElementById(e.target.id).value = "";
      document.getElementById("modal-alert").click();

      this.setState({
        msgAlert: "Selecione o mês e ano de competência dos documentos!",
        classText: "text-danger",
        load: false
      });
    }
  };

  // Retorna Icone dos documentos conforme status
  verifyDocumentIcon = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId === id
    );

    if (exist.length) {
      const status = exist[0].AttachmentStatusId;
      // 1 - Aguardando Aprovação
      if (status === 1) {
        return "fa fa-clock-o";
        // 2 - Aprovado
      } else if (status === 2) {
        return "fa fa-check text-success";
        // 4 - Rejeitado
      } else if (status === 4) {
        return "fa fa-times text-danger";
      }
    } else {
      // Sem status
      return "fa fa-circle-thin";
    }
  };

  verifyDocumentApplicable = id => {
    const exist = this.state.companyDocuments.filter(
      item => item.DocumentId == id
    );
    return exist.length > 0 ? exist[0].notapplicable : false;
  };

  //
  sendApproval = async () => {
    const { companyDocuments, documentsToUpload } = this.state;
    console.log("TCL: sendApproval -> companyDocuments", companyDocuments);
    console.log("TCL: sendApproval -> documentsToUpload", documentsToUpload);

    // Retorna todos os documentos que já foram enviados, aprovados e com a data selecionada
    const allDocumentsInDateAlreadySubmited = companyDocuments.filter(
      item => item.AttachmentStatusId === 2
    );
    console.log(
      "TCL: sendApproval -> allDocumentsInDateAlreadySubmited",
      allDocumentsInDateAlreadySubmited
    );

    // Valida se os docs a serem enviados/selecionados possuem a mesma qtde dos documentos do tipo empresa periódico
    if (documentsToUpload.length === companyDocuments.length) {
      this.setState({ showAprovacaoPeriodic: true });
    } else {
      this.setState({
        showAprovacaoPeriodic: false
      });
    }

    // Valoda se os docs a serem enviados possuem a mesma qtde dos documentos aprovados do tipo empresa periódico
    if (documentsToUpload.length === allDocumentsInDateAlreadySubmited.length) {
      this.setState({
        allDocumentsInDateAlreadySubmited: true
      });
    } else {
      this.setState({
        allDocumentsInDateAlreadySubmited: false
      });
    }
  };

  //Apenas modal de confirmação
  confirmAlterStatusCompany = async event => {
    event.preventDefault();
    this.setState({ erroDelete: null });

    document.getElementById("modal-confirm").click();
  };

  //Altera o status da empresa
  alterStatusCompany = async e => {
    this.setState({ load: true });
    console.log("Entrou na alteração de status");

    const ids = this.state.documentsToUpload.map(doc => doc.id);

    await api
      .patch(`/companies/${localStorage.getItem("CompanyId")}`, {
        CompanyStatusId: 3,
        SectorId: this.state.sectorId,

        DocumentIds: ids
      })
      .then(result => {
        this.setState({ load: false, erroDelete: null });
        document.getElementById("close-modal-confirm").click();
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
        this.searchDocumentsCompany();
        this.searchDocumentsToCompany();
      })
      .catch(err => {
        if (err) {
          this.setState({
            msgAlert: "Deu algo de errado!",
            classText: "text-danger",
            load: false
          });
        } else {
          this.setState({
            msgAlert: "Erro no envio. Tente novamente!",
            classText: "text-danger",
            load: false
          });
        }
      });
  };

  // Seta no estado caso exista documentos com status: Rejeitado
  verifyStatusDocuments = () => {
    const exist = this.state.companyDocuments.filter(
      item => item.AttachmentStatusId === 4
    );
    this.setState({ rejectDocument: exist.length ? true : false });
  };

  // Para mostrar o botão de Enviar para aprovação
  showSubmitButtonByStatusCompany = () => {
    const {
      companyStatus,
      showAprovacaoPeriodic,
      allDocumentsInDateAlreadySubmited,
      rejectDocument
    } = this.state;
    console.log("companyStatus", companyStatus);
    console.log("showAprovacaoPeriodic", showAprovacaoPeriodic);
    console.log(
      "allDocumentsInDateAlreadySubmited",
      allDocumentsInDateAlreadySubmited
    );
    console.log("rejectDocument", rejectDocument);

    /**
     * Status 2 = Envio de documentos da empresa
     * Status 3 = Aprovação de documentos da empresa
     * Status 4 = Documentos da empresa rejeitados
     * Status 5 = Habilitado
     * showAprovacaoPeriodic = Se todos os documentos periódicos pendentes de envio já foram selecionados
     */

    if (companyStatus === 2 || companyStatus === 3) {
      console.log(
        "Status: Envio de documento ou Aprovação de documentos da empresa"
      );
      return false;
    } else if (
      showAprovacaoPeriodic &&
      companyStatus === 5 &&
      !allDocumentsInDateAlreadySubmited
    ) {
      console.log(
        "Case showAprovacaoPeriodic / companyStatus - Habilitada / allDocumentsInDateAlreadySubmited: ",
        showAprovacaoPeriodic,
        companyStatus
      );
      return true;
    } else if (allDocumentsInDateAlreadySubmited === true) {
      console.log(
        "Case Todos os documentos foram enviados e aprovados nesta data selecionada"
      );
      return false;
    } else if (!rejectDocument && companyStatus === 4) {
      console.log("5");
      return true;
    }
    console.log("Nenhuma das opções");
    return false;
  };

  //Upload de documentos de medição
  uploadMedicaoDocument = async e => {
    const { month, year } = this.state;
    const documentId = e.target.getAttribute("data-document-id");
    const isNotApplicable = e.target.getAttribute("data-not-applicable") === "true";

    const data = new FormData();
    
    if (!isNotApplicable) {
      const file = e.target.files[0];
      if (!file) return;
      data.append("attachment", file);
    }

    data.append("DocumentId", documentId);
    data.append("month", month);
    data.append("year", year);
    data.append("notapplicable", isNotApplicable);

    try {
      this.setState({ load: true });
      await api.post(`/companies/${localStorage.getItem("CompanyId")}/attachments`, data);
      await this.searchMedicaoDocuments();
      
      // Clear file input
      if (e.target) {
        e.target.value = "";
      }
      
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: "Documento de medição enviado com sucesso!",
        classText: "text-success",
        load: false
      });
    } catch (err) {
      console.log(err);
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: "Erro ao enviar documento de medição",
        classText: "text-danger",
        load: false
      });
    }
  };

  //Verifica o ícone do documento baseado no status - Medição
  verifyMedicaoDocumentIcon = id => {
    const { medicaoDocuments } = this.state;
    const document = medicaoDocuments.find(doc => doc.DocumentId == id);
    
    if (!document) return "fa fa-circle-thin";
    
    switch (document.AttachmentStatusId) {
      case 1: // Aguardando Aprovação
        return "fa fa-clock-o";
      case 2: // Aprovado
        return "fa fa-check text-success";
      case 4: // Rejeitado
        return "fa fa-times text-danger";
      default:
        return "fa fa-circle-thin";
    }
  };

  //Verifica se pode mostrar botão de upload - Medição
  showMedicaoFileButton = id => {
    const icon = this.verifyMedicaoDocumentIcon(id);
    return icon === "fa fa-circle-thin" || icon === "fa fa-times text-danger";
  };

  //Controla documento de medição como aplicável/não aplicável
  checkMedicaoDocument = async e => {
    const { month, year } = this.state;
    const isChecked = e.target.checked;
    const documentId = e.target.value;
    const targetId = e.target.id;
    
    if (year && month) {
      const data = {
        DocumentId: documentId,
        notapplicable: isChecked ? true : false,
        month: month,
        year: year
      };

      try {
        this.setState({ load: true });
        await api.post(`/companies/${localStorage.getItem("CompanyId")}/attachments`, data);
        await this.searchMedicaoDocuments();
        
        document.getElementById("modal-alert").click();
        this.setState({ 
          msgAlert: isChecked ? 
            "Documento de medição marcado como não aplicável" : 
            "Documento de medição marcado como aplicável",
          classText: "text-success",
          load: false
        });
      } catch (err) {
        console.log(err);
        document.getElementById("modal-alert").click();
        this.setState({ 
          msgAlert: "Erro ao marcar documento de medição",
          classText: "text-danger",
          load: false
        });
      }
    } else {
      if (document.getElementById(targetId)) {
        document.getElementById(targetId).checked = false;
      }
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: "Selecione o mês e ano de competência dos documentos!",
        classText: "text-danger"
      });
    }
  };

  // Retorna o nome do arquivo para label da lista - Medição
  verifyMedicaoDocument = id => {
    const exist = this.state.medicaoDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].originalName : "";
  };

  // Verifica observação/justificativa quando reprovado - Medição
  verifyMedicaoDocumentNote = id => {
    const exist = this.state.medicaoDocuments.filter(
      item => item.DocumentId === id
    );
    return exist.length > 0 ? exist[0].note : "";
  };

  verifyMedicaoDocumentApplicable = id => {
    const exist = this.state.medicaoDocuments.filter(
      item => item.DocumentId == id
    );
    return exist.length > 0 ? exist[0].notapplicable : false;
  };

  handleChangeDate = async e => {
    const { name, value } = e.target;
    const { documentsToUpload } = this.state;

    this.setState({ [name]: value }, async () => {
      const { year, month } = this.state;

      const companyDocuments = await api.get(
        `/companies/${localStorage.getItem(
          "CompanyId"
        )}/attachments?DocumentTypeId=2&year=${year}&month=${month}`
      );
      console.log(
        "TCL: searchDocumentsCompany -> companyDocuments",
        companyDocuments
      );
      this.setState((state, props) => ({
        ...state,
        companyDocuments: companyDocuments.data.rows || {},
        allDocumentsInDateAlreadySubmited:
          companyDocuments.data.rows.filter(
            item => item.AttachmentStatusId === 2
          ).length === documentsToUpload.length
      }));
      
      // Also update Medição documents for the selected month/year
      await this.searchMedicaoDocuments();
      
      this.sendApproval();
      this.forceUpdate();
    });
  };

  render() {
    const {
      year,
      month,
      companyStatusDescription,
      load,
      documentsToUpload,
      medicaoDocumentsToUpload,
      medicaoDocuments,
      companyStatus,
      msgFile,
      showAprovacaoPeriodic,
      employees,
      erroDelete,
      classText,
      msgAlert
    } = this.state;
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="align-self-center">
            <h3 className="text-themecolor">
              Documentos Mensais
              {load ? <i className="fa fa-spin fa-spinner" /> : null}
            </h3>
          </div>
        </div>
        <form id="formDocuments">
          <div
            className={
              companyStatusDescription === "Habilitado"
                ? "row alert alert-success"
                : "row alert alert-primary"
            }
          >
            <span>
              Status da empresa:
              <strong> {companyStatusDescription}</strong>
            </span>
          </div>
          <div className="row card">
            <div className="col-md-12">
              <div className="card-body">
                <h4 className="card-title">
                  Envio de documentos periódicos para credenciamento da empresa
                  {load ? (
                    <i className="text-info">
                      {" "}
                      - <i className="fa fa-spin fa-spinner" /> Processando
                      arquivo
                    </i>
                  ) : null}
                </h4>
                {/* Lista de meses e anos */}
                <DropMonthYear
                  year={year}
                  month={month}
                  handleChangeDate={this.handleChangeDate}
                />
                <div className="feeds" style={{ overflowX: "hidden" }}>
                  {documentsToUpload.length
                    ? documentsToUpload.map(item => {
                        return (
                          <div
                            key={item.id}
                            className="row"
                            style={{ padding: "37px" }}
                          >
                            <i className={this.verifyDocumentIcon(item.id)} />

                            <div className="col-md-2">{item.description}</div>
                            <div className="col-md-2">
                              {this.verifyDocumentNote(item.id) ? (
                                <i className="text-danger label label-light-danger">
                                  {this.verifyDocumentNote(item.id)}
                                  ...
                                </i>
                              ) : null}

                              {this.verifyDocumentExpired(item.id) ? (
                                <i className="text-danger label label-light-danger">
                                  {this.verifyDocumentExpired(item.id)}
                                </i>
                              ) : null}
                            </div>

                            <div className="col-md-3">
                              {this.verifyDocument(item.id) ? (
                                <i
                                  alt={this.verifyDocument(item.id)}
                                  title={this.verifyDocument(item.id)}
                                  className={
                                    this.verifyDocument(item.id)
                                      ? "text-success label label-light-success"
                                      : "text-danger label label-light-danger"
                                  }
                                >
                                  <i className="fa fa-check" />
                                  {this.verifyDocument(item.id)}
                                </i>
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {this.showFileButton(item.id) ? (
                                <input
                                  type="file"
                                  style={{ width: "150px" }}
                                  id={item.id}
                                  onChange={this.uploadDocument}
                                />
                              ) : null}
                            </div>

                            <div className="col-md-2">
                              {(companyStatus == 5 || companyStatus == 4) &&
                              this.verifyDocumentIcon(item.id) !=
                                "fa fa-check text-success" ? (
                                <div key={item.id} className="text-right p-10">
                                  <input
                                    type="checkbox"
                                    checked={this.verifyDocumentApplicable(
                                      item.id
                                    )}
                                    name="not_applicable"
                                    value={item.id}
                                    id={"document_" + item.id}
                                    onClick={this.checkDocument}
                                  />
                                  <label htmlFor={"document_" + item.id}>
                                    {" "}
                                    Não Aplicável{" "}
                                  </label>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div className="col-md-12 text-center p-20">
              {/* 
                documentsToUpload: Verifica se possui documentos a serem enviados
                showAprovacaoPeriodic: Verifica se os documentos mensais foram enviados para aprovação
                rejecteDocument: Verifica se algum documento com status Rejeitado
                companyStatus: Verifica o status da empresa 
                2 - "Envio de documentos da empresa"
                3 - "Aprovação de documentos da empresa"
                4 - "Documentos da empresa rejeitados"
              */}
              {this.showSubmitButtonByStatusCompany() ? (
                <button
                  className="btn btn-success"
                  onClick={this.confirmAlterStatusCompany}
                >
                  Enviar para aprovação
                </button>
              ) : null}


              {/* Se todos os documentos não foram enviados e
                status igual "Envio de documentos da empresa" ou
                status igual "Documentos da empresa rejeitados"
                Renderiza alerta para anexar todos os docs
              */}
              {!showAprovacaoPeriodic &&
                (companyStatus == 2 || companyStatus == 4) && (
                  <div className="alert alert-danger">
                    Para enviar os documentos para aprovação é necessário anexar
                    todos os documentos!
                  </div>
                )}

              {companyStatus === 3 && (
                <div className="alert alert-info">
                  Seus documentos estão em processo de aprovação!
                </div>
              )}
            </div>
          </div>
        </form>

        {/* Seção de Documentos de Medição */}
        <div className="row card mt-4">
          <div className="col-md-12">
            <div className="card-body">
              <h4 className="card-title">
                Documentos de Medição
                {load ? (
                  <i className="text-info">
                    {" "}
                    - <i className="fa fa-spin fa-spinner" /> Processando
                    arquivo
                  </i>
                ) : null}
              </h4>
              
              {medicaoDocumentsToUpload.length > 0 ? (
                <div>
                  <div className="feeds" style={{ overflowX: "hidden" }}>
                    {medicaoDocumentsToUpload.map(item => {
                      return (
                        <div
                          key={item.id}
                          className="row"
                          style={{ padding: "37px" }}
                        >
                          <i className={this.verifyMedicaoDocumentIcon(item.id)} />

                          <div className="col-md-2">{item.description}</div>
                          <div className="col-md-2">
                            {this.verifyMedicaoDocumentNote(item.id) ? (
                              <i className="text-danger label label-light-danger">
                                {this.verifyMedicaoDocumentNote(item.id)}
                                ...
                              </i>
                            ) : null}
                          </div>

                          <div className="col-md-3">
                            {this.verifyMedicaoDocument(item.id) ? (
                              <i
                                alt={this.verifyMedicaoDocument(item.id)}
                                title={this.verifyMedicaoDocument(item.id)}
                                className={
                                  this.verifyMedicaoDocument(item.id)
                                    ? "text-success label label-light-success"
                                    : "text-danger label label-light-danger"
                                }
                              >
                                <i className="fa fa-check" />
                                {this.verifyMedicaoDocument(item.id)}
                              </i>
                            ) : null}
                          </div>

                          <div className="col-md-2">
                            {this.showMedicaoFileButton(item.id) ? (
                              <input
                                type="file"
                                style={{ width: "150px" }}
                                data-document-id={item.id}
                                onChange={this.uploadMedicaoDocument}
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              />
                            ) : null}
                          </div>

                          <div className="col-md-2">
                            {this.showMedicaoFileButton(item.id) ? (
                              <div key={item.id} className="text-right p-10">
                                <input
                                  type="checkbox"
                                  checked={this.verifyMedicaoDocumentApplicable(item.id)}
                                  name="not_applicable_medicao"
                                  value={item.id}
                                  id={"medicao_document_" + item.id}
                                  onClick={this.checkMedicaoDocument}
                                />
                                <label htmlFor={"medicao_document_" + item.id}>
                                  {" "}
                                  Não Aplicável{" "}
                                </label>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <p>Nenhum documento de medição encontrado para este tipo de empresa.</p>
              )}
            </div>
          </div>
        </div>

        <fieldset>
          <legend>Funcionários</legend>
          <div className="card table-responsive p-20">
            <table className="table table-striped m-t-20">
              <thead>
                <tr>
                  <td>Nome</td>
                  <td>Email</td>
                  <td>Setor</td>
                  <td>Status</td>
                  <td />
                </tr>
              </thead>
              <tbody>
                {employees.length
                  ? employees.sort((a, b) => a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase())).map((item, index) => {
                      return (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>{item.email}</td>
                          <td>{item.Sector ? item.Sector.name : null}</td>
                          <td>{item.EmployeeStatus.description}</td>
                          <td>
                            {companyStatus >= 2 ? (
                              <a
                                href={`../employee-periodic/${item.id}`}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="btn btn-rounded btn-outline-info"
                              >
                                <i className="fa fa-files-o" /> Documentos
                                Mensais
                              </a>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        </fieldset>

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja enviar os documentos para aprovação?"
          load={load}
          function={this.alterStatusCompany}
          msgError={erroDelete}
        />
        <ModalAlert
          title="Envio de Documento(s)"
          msg={msgAlert}
          function=""
          classText={classText}
        />
      </Fragment>
    );
  }
}

export default Company;
